var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowShare = function SvgArrowShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M16.719 9.505c.203-.174.304-.26.341-.364a.42.42 0 0 0 0-.282c-.037-.103-.138-.19-.341-.364L9.67 2.453c-.35-.3-.524-.45-.672-.453a.42.42 0 0 0-.333.153c-.094.115-.094.345-.094.806v3.574a8.04 8.04 0 0 0-6.656 7.918v.509a9.49 9.49 0 0 1 6.656-3.405v3.486c0 .46 0 .691.094.806.081.1.204.156.333.153.148-.004.323-.154.672-.453z"
  })));
};
export default SvgArrowShare;